import { render, staticRenderFns } from "./wind-speed.vue?vue&type=template&id=09014cd9&"
import script from "./wind-speed.vue?vue&type=script&lang=js&"
export * from "./wind-speed.vue?vue&type=script&lang=js&"
import style0 from "./wind-speed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports